import { useState, useMemo } from "react";
import subMonths from "date-fns/subMonths";

import { UseMonthPickerProps, UseMonthPickerReturnValue } from "./types";
import { getMonthSelectOptions } from "./utils";

const useMonthSelect = <IsMulti extends boolean = false>({
  isMulti,
  count = 24,
  preceding = 0,
  todayAsDefaultValue,
}: UseMonthPickerProps<IsMulti> = {}): UseMonthPickerReturnValue<IsMulti> => {
  const [value, onChange] =
    useState<UseMonthPickerReturnValue<IsMulti>["value"]>();

  const options = useMemo(
    () =>
      getMonthSelectOptions(
        preceding + count,
        subMonths(new Date(), preceding)
      ),
    [count, preceding]
  );

  return useMemo(() => {
    const defaultValue = (
      isMulti ? options.slice(preceding, 1) : options[preceding]
    ) as UseMonthPickerReturnValue<IsMulti>["value"];

    return {
      value: value || (todayAsDefaultValue ? defaultValue : undefined),
      onChange,
      isMulti,
      options,
    };
  }, [isMulti, options, preceding, value, todayAsDefaultValue]);
};

export default useMonthSelect;
